import { IApiProduct, IProduct } from './IProduct'
import { IApiProductBrand, IProductBrand } from './IProductBrand'
import { IApiProductCategory, IProductCategory } from './IProductCategory'

class Transformer {
    static transformProduct(data: IApiProduct): IProduct {
        return {
            id: Number(data.id),
            name: data.name,
            categoryId: data.category_id ? Number(data.category_id) : null,
            code: data.code ?? null,
            barcode: data.barcode ?? null,
            previousBarcode: data.previous_barcode ?? null,
            purchasePrice: data.purchase_price
                ? Number(data.purchase_price)
                : null,
            salePrice: data.sale_price ? Number(data.sale_price) : null,
            inStock: data.in_stock ? Number(data.in_stock) : null,
            minStock: data.min_stock ? Number(data.min_stock) : null,
            maxStock: data.max_stock ? Number(data.max_stock) : null,
        }
    }

    static reverseTransformProduct(product: IProduct): IApiProduct {
        const apiProduct: IApiProduct = {
            id: product.id,
            name: product.name,
            category_id: product.categoryId,
            code: product.code,
            barcode: product.barcode,
            previous_barcode: product.previousBarcode,
            purchase_price: product.purchasePrice,
            sale_price: product.salePrice,
            in_stock: product.inStock,
            min_stock: product.minStock,
            max_stock: product.maxStock,
        }

        return apiProduct
    }

    static transformProductBrand(data: IApiProductBrand): IProductBrand {
        return {
            id: Number(data.id),
            name: data.name,
            categories:
                typeof data.categories === 'undefined'
                    ? []
                    : data.categories.map((category: IApiProductCategory) => {
                          return {
                              id: category.id,
                              name: category.name,
                          }
                      }),
        }
    }
}

export default Transformer
